import { SIZE } from '@app/constants'
import { SEPARATOR } from '@app/constants/separator'
import { FILTERS_PARAMS_KEYS } from '@app/api/constants'

import { getTodayDate } from '@app/utils/date'

import type { LntSelectProps } from '@app/components/base/Select/types'

export const commonSelectProps: LntSelectProps<number[]> = {
  showArrow: true,
  mode: 'multiple',
  size: SIZE.middle,
  strictValue: true,
  tokenSeparators: [SEPARATOR.newline]
}

export const defaultWeekPeriod = {
  [FILTERS_PARAMS_KEYS.week]: getTodayDate().week().toString()
}
